import React from 'react'
import { getImages } from './const'

const MarkBrand = () => {
  return (
    <>
        <section className='sc-brand-wrap'>
            <div className='container'>
                <div className='wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                    <div className='sm-title text-center text-uppercase font-1-5em mb-5'>WE ARE EXPERIENCED WORKING ON THESE BRANDS AND MORE</div>
                    <div className='d-flex align-items-center justify-content-between sc-brand-flex'>
                        <div>
                            <img src={getImages('logos/Lamborghini.png')} />
                        </div>
                        <div>
                            <img src={getImages('logos/Mercedes-Benz.png')} />
                        </div>
                        <div>
                            <img src={getImages('logos/Maserati.png')} />
                        </div>
                        <div>
                            <img src={getImages('logos/ferrari-logo.png')} />
                        </div>
                        <div>
                            <img src={getImages('logos/Porsche.png')} />
                        </div>
                        <div>
                            <img src={getImages('logos/Bentley.png')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default MarkBrand